<template>
   <div class="block-process-affair">
      <div class="row">
         <div class="col-12 text-center">
            <ejs-listview class="affairList" :dataSource='dataSource' showHeader='true' :fields='fields'></ejs-listview>
         </div>
      </div>
      <div class="row">
         <div class="col-12" v-html="content"></div>
      </div>
   </div>
</template>

<script>
import axios from 'axios'
import { ListViewPlugin } from "@syncfusion/ej2-vue-lists";
Vue.use(ListViewPlugin);

export default {
   name: "processes-detail-process-affair",
   props: ["data"],
	data () {
		return {
            title: '',
            denomination: '',
            content: '',
            dataSource: [],
            fields: {text: 'asunto', groupBy: 'clasification'},
      }
   },
	methods: {
		initProcessAffair: function() {
            axios.post('/auth/processes/getSubjectProcess', {
                processId: this.data.id
            }).then(response => {
                this.dataSource = response.data;
            });
      }
	},
	created: function() {
        this.initProcessAffair();
  }
}
</script>